const POLISH_CITIES = [
  "Białystok",
  "Bielsko-Biała",
  "Bydgoszcz",
  "Bełchatów",
  "Bochnia",
  "Brzeg",
  "Częstochowa",
  "Chorzów",
  "Chełm",
  "Chojnice",
  "Dąbrowa Górnicza",
  "Dębica",
  "Gdańsk",
  "Gdynia",
  "Gliwice",
  "Głogów",
  "Gniezno",
  "Gorlice",
  "Gorzów Wielkopolski",
  "Grudziądz",
  "Inowrocław",
  "Jarosław",
  "Jasło",
  "Katowice",
  "Kielce",
  "Kraków",
  "Kędzierzyn-Koźle",
  "Kalisz",
  "Konin",
  "Koszalin",
  "Krosno",
  "Kutno",
  "Legionowo",
  "Legnica",
  "Lublin",
  "Łódź",
  "Łomża",
  "Malbork",
  "Mielec",
  "Mysłowice",
  "Nowy Sącz",
  "Nowy Targ",
  "Nysa",
  "Olsztyn",
  "Opole",
  "Ostrów Wielkopolski",
  "Ostrowiec Świętokrzyski",
  "Oświęcim",
  "Poznań",
  "Radom",
  "Racibórz",
  "Rumia",
  "Rzeszów",
  "Sandomierz",
  "Sanok",
  "Siedlce",
  "Siemianowice Śląskie",
  "Sopot",
  "Szczecin",
  "Świdnica",
  "Świdnik",
  "Świętochłowice",
  "Skierniewice",
  "Słupsk",
  "Stalowa Wola",
  "Starachowice",
  "Stargard",
  "Starogard Gdański",
  "Suwałki",
  "Toruń",
  "Tarnobrzeg",
  "Tarnowskie Góry",
  "Tarnów",
  "Tczew",
  "Tychy",
  "Wałbrzych",
  "Warszawa",
  "Wejherowo",
  "Włocławek",
  "Wrocław",
  "Zabrze",
  "Zamość",
  "Zawiercie",
  "Zielona Góra",
  "Żory",
  "Żyrardów"
];

const CITY_LABELS = {
  Warszawa: "Warsaw"
};

export const POLISH_CITY_OPTIONS = POLISH_CITIES.map((value) => ({
  label: CITY_LABELS[value] || value,
  value
}));

export function getCanonicalPolishCity(city) {
  const normalizedCity = String(city || "").trim();
  const matchingOption = POLISH_CITY_OPTIONS.find(
    ({ label, value }) =>
      label.toLocaleLowerCase() === normalizedCity.toLocaleLowerCase() ||
      value.toLocaleLowerCase() === normalizedCity.toLocaleLowerCase()
  );

  return matchingOption ? matchingOption.value : normalizedCity;
}

export default POLISH_CITIES;
